import { combineReducers } from 'redux';
import {
  INGREDIENT_LIBRARY_CLOSE_RIGHT_COLUMN,
  INGREDIENT_LIBRARY_CREATE_CATEGORY_HIDE_MODAL,
  INGREDIENT_LIBRARY_CREATE_CATEGORY_SHOW_MODAL,
  INGREDIENT_LIBRARY_EXPORT_DONE,
  INGREDIENT_LIBRARY_EXPORT_START,
  INGREDIENT_LIBRARY_HIDE_COGS_MODAL,
  INGREDIENT_LIBRARY_HIDE_DELETE_MODAL,
  INGREDIENT_LIBRARY_HIDE_IMPORT_MODAL,
  INGREDIENT_LIBRARY_HIDE_ITEM_INVENTORY_ALERT_MODAL,
  INGREDIENT_LIBRARY_HIDE_ITEM_VARIANT_MODAL,
  INGREDIENT_LIBRARY_HIDE_SAVE_TO_ALL_OUTLETS_MODAL,
  INGREDIENT_LIBRARY_IS_SUBMITTING_FORM,
  INGREDIENT_LIBRARY_ON_DELETE_IMAGE,
  INGREDIENT_LIBRARY_ON_DROP_IMAGE,
  INGREDIENT_LIBRARY_OPEN_RIGHT_COLUMN,
  INGREDIENT_LIBRARY_SET_ASYNCJOBID,
  INGREDIENT_LIBRARY_SET_CATEGORY_LIST,
  INGREDIENT_LIBRARY_SET_CREATED_OUTLETS,
  INGREDIENT_LIBRARY_SET_CURRENT_CATEGORY_ID,
  INGREDIENT_LIBRARY_SET_CURRENT_INVENTORY_ID,
  INGREDIENT_LIBRARY_SET_CURRENT_ITEM_ID,
  INGREDIENT_LIBRARY_SET_CURRENT_PAGE,
  INGREDIENT_LIBRARY_SET_EXPORTING_INGREDIENT,
  INGREDIENT_LIBRARY_SET_FILTER_STATE,
  INGREDIENT_LIBRARY_SET_ITEM_DETAIL,
  INGREDIENT_LIBRARY_SET_ITEM_LIST,
  INGREDIENT_LIBRARY_SET_MODIFIERS,
  INGREDIENT_LIBRARY_SET_NEW_CATEGORY,
  INGREDIENT_LIBRARY_SET_OUTLETS,
  INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORIES,
  INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORY_ID,
  INGREDIENT_LIBRARY_SET_PREVIOUS_ITEM_FORM,
  INGREDIENT_LIBRARY_SET_TOTAL_PAGE,
  INGREDIENT_LIBRARY_SET_TYPE_IMPORT,
  INGREDIENT_LIBRARY_SET_UNITS,
  INGREDIENT_LIBRARY_SHOW_COGS_MODAL,
  INGREDIENT_LIBRARY_SHOW_DELETE_MODAL,
  INGREDIENT_LIBRARY_SHOW_IMPORT_MODAL,
  INGREDIENT_LIBRARY_SHOW_INPUT_COGS,
  INGREDIENT_LIBRARY_SHOW_INPUT_INVENTORY,
  INGREDIENT_LIBRARY_SHOW_ITEM_INVENTORY_ALERT_MODAL,
  INGREDIENT_LIBRARY_SHOW_ITEM_VARIANT_MODAL,
  INGREDIENT_LIBRARY_SHOW_SAVE_TO_ALL_OUTLETS_MODAL,
  INGREDIENT_LIBRARY_SHOW_SECTION_UPLOADER,
  INGREDIENT_LIBRARY_STORE_UNCATEGORIZED,
  INGREDIENT_LIBRARY_UNSET_FILTER_STATE,
} from 'actions/ingredients/library/constants';
import createReducer from 'utils/createReducer';

const categories = createReducer([], {
  [INGREDIENT_LIBRARY_SET_CATEGORY_LIST]: (draft, { payload }) =>
    payload.categories,
});

const createdOutlets = createReducer(null, {
  [INGREDIENT_LIBRARY_SET_CREATED_OUTLETS]: (draft, { payload }) =>
    payload.createdOutlets,
});

const currentCategoryId = createReducer(0, {
  [INGREDIENT_LIBRARY_SET_CURRENT_CATEGORY_ID]: (draft, { payload }) =>
    payload.categoryId,
});

const currentInventoryId = createReducer(0, {
  [INGREDIENT_LIBRARY_SET_CURRENT_INVENTORY_ID]: (draft, { payload }) =>
    payload.inventoryId,
});

const currentItemId = createReducer('', {
  [INGREDIENT_LIBRARY_SET_CURRENT_ITEM_ID]: (draft, { payload }) =>
    payload.currentItemId,
});

const currentPage = createReducer(null, {
  [INGREDIENT_LIBRARY_SET_CURRENT_PAGE]: (draft, { payload }) =>
    payload.currentPage,
});

const deletedLibrary = createReducer(null, {});

const exportingIngredient = createReducer(false, {
  [INGREDIENT_LIBRARY_SET_EXPORTING_INGREDIENT]: (draft, { payload }) =>
    payload.exporting,
});

const files = createReducer(null, {
  [INGREDIENT_LIBRARY_ON_DROP_IMAGE]: (draft, { payload }) =>
    payload.fileStateacceptedFiles,
  [INGREDIENT_LIBRARY_ON_DELETE_IMAGE]: (draft, { payload }) =>
    payload.fileStateacceptedFiles,
});

const filterState = createReducer(
  {
    categoryId: 0,
    typeInventoryId: 0,
    keyword: '',
  },
  {
    [INGREDIENT_LIBRARY_SET_FILTER_STATE]: (draft, { payload }) => ({
      categoryId: payload.categoryId,
      typeInventoryId: payload.typeInventoryId,
      keyword: payload.keyword,
    }),
    [INGREDIENT_LIBRARY_UNSET_FILTER_STATE]: () => ({
      categoryId: 0,
      typeInventoryId: 0,
      keyword: '',
    }),
  }
);

const gravatar = createReducer(null, {
  [INGREDIENT_LIBRARY_ON_DELETE_IMAGE]: (draft, { payload }) =>
    payload.fileStategravatar,
});

const idAsyncJob = createReducer(null, {
  [INGREDIENT_LIBRARY_SET_ASYNCJOBID]: (draft, { payload }) =>
    payload.idAsyncJob,
});

const importType = createReducer('modify', {
  [INGREDIENT_LIBRARY_SET_TYPE_IMPORT]: (draft, { payload }) =>
    payload.importType,
});

const inventories = createReducer(
  [
    { id: '0', name: 'All Inventory' },
    { id: '1', name: 'Low Stock Alert' },
    { id: '2', name: 'Out of Stock Alert' },
  ],
  {}
);

const isExportLoading = createReducer(false, {
  [INGREDIENT_LIBRARY_EXPORT_START]: () => true,
  [INGREDIENT_LIBRARY_EXPORT_DONE]: () => false,
});

const isSubmittingForm = createReducer(false, {
  [INGREDIENT_LIBRARY_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    payload.isSubmittingForm,
});

const libraries = createReducer(
  {
    total_pages: 0,
    total_libraries: 0,
    results: [],
  },
  {
    [INGREDIENT_LIBRARY_SET_ITEM_LIST]: (draft, { payload }) =>
      payload.libraries,
  }
);

const libraryDetail = createReducer(null, {
  [INGREDIENT_LIBRARY_SET_ITEM_DETAIL]: (draft, { payload }) => payload.library,
});

const modifierIds = createReducer([], {});

const modifiers = createReducer([], {
  [INGREDIENT_LIBRARY_SET_MODIFIERS]: (draft, { payload }) => payload.modifiers,
});

const newCategory = createReducer(null, {
  [INGREDIENT_LIBRARY_SET_NEW_CATEGORY]: (draft, { payload }) =>
    payload.category,
});

const openRightColumn = createReducer(false, {
  [INGREDIENT_LIBRARY_OPEN_RIGHT_COLUMN]: () => true,
  [INGREDIENT_LIBRARY_CLOSE_RIGHT_COLUMN]: () => false,
});

const outlets = createReducer([], {
  [INGREDIENT_LIBRARY_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const previousCategories = createReducer([], {
  [INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORIES]: (draft, { payload }) =>
    payload.categories,
});

const previousCategoryId = createReducer(null, {
  [INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORY_ID]: (draft, { payload }) =>
    payload.categoryId,
});

const previousLibraryForm = createReducer(
  {
    name: null,
    category: null,
    libraryVariant: [],
    libraryInventory: [],
    libraryModifier: [],
    description: null,
  },
  {
    [INGREDIENT_LIBRARY_SET_PREVIOUS_ITEM_FORM]: (draft, { payload }) =>
      payload.previousLibraryForm,
  }
);

const removeImage = createReducer(false, {
  [INGREDIENT_LIBRARY_ON_DROP_IMAGE]: (draft, { payload }) =>
    payload.fileStateremoveImage,
  [INGREDIENT_LIBRARY_ON_DELETE_IMAGE]: (draft, { payload }) =>
    payload.fileStateremoveImage,
});

const search = createReducer('', {});

const showCOGSModal = createReducer(false, {
  [INGREDIENT_LIBRARY_SHOW_COGS_MODAL]: () => true,
  [INGREDIENT_LIBRARY_HIDE_COGS_MODAL]: () => false,
});

const showDeleteLibraryModal = createReducer(false, {});

const showDeleteModal = createReducer(false, {
  [INGREDIENT_LIBRARY_SHOW_DELETE_MODAL]: () => true,
  [INGREDIENT_LIBRARY_HIDE_DELETE_MODAL]: () => false,
});

const showImportModal = createReducer(false, {
  [INGREDIENT_LIBRARY_SHOW_IMPORT_MODAL]: () => true,
  [INGREDIENT_LIBRARY_HIDE_IMPORT_MODAL]: () => false,
});

const showInputCOGS = createReducer(false, {
  [INGREDIENT_LIBRARY_SHOW_INPUT_COGS]: (draft, { payload }) =>
    payload.showInputCOGS,
});

const showInputInventory = createReducer(false, {
  [INGREDIENT_LIBRARY_SHOW_INPUT_INVENTORY]: (draft, { payload }) =>
    payload.showInputInventory,
});

const showLibraryInventoryAlertModal = createReducer(false, {
  [INGREDIENT_LIBRARY_SHOW_ITEM_INVENTORY_ALERT_MODAL]: () => true,
  [INGREDIENT_LIBRARY_HIDE_ITEM_INVENTORY_ALERT_MODAL]: () => false,
});

const showLibraryVariantModal = createReducer(false, {
  [INGREDIENT_LIBRARY_SHOW_ITEM_VARIANT_MODAL]: () => true,
  [INGREDIENT_LIBRARY_HIDE_ITEM_VARIANT_MODAL]: () => false,
});

const showNewCategoryModal = createReducer(false, {
  [INGREDIENT_LIBRARY_CREATE_CATEGORY_SHOW_MODAL]: () => true,
  [INGREDIENT_LIBRARY_CREATE_CATEGORY_HIDE_MODAL]: () => false,
});

const showSaveToAllOutletsModal = createReducer(false, {
  [INGREDIENT_LIBRARY_SHOW_SAVE_TO_ALL_OUTLETS_MODAL]: () => true,
  [INGREDIENT_LIBRARY_HIDE_SAVE_TO_ALL_OUTLETS_MODAL]: () => false,
});

const showSectionUploader = createReducer(false, {
  [INGREDIENT_LIBRARY_SHOW_SECTION_UPLOADER]: (draft, { payload }) =>
    payload.showSectionUploader,
});

const showUploadValidationModal = createReducer(false, {});

const tempFiles = createReducer({}, {});

const textModal = createReducer('', {});

const totalPage = createReducer(null, {
  [INGREDIENT_LIBRARY_SET_TOTAL_PAGE]: (draft, { payload }) =>
    payload.totalPage,
});

const uncategorized = createReducer(
  {},
  {
    [INGREDIENT_LIBRARY_STORE_UNCATEGORIZED]: (draft, { payload }) =>
      payload.uncategorized,
  }
);

const units = createReducer([], {
  [INGREDIENT_LIBRARY_SET_UNITS]: (draft, { payload }) => payload.units,
});

export default combineReducers({
  categories,
  createdOutlets,
  currentCategoryId,
  currentInventoryId,
  currentItemId,
  currentPage,
  deletedLibrary,
  exportingIngredient,
  files,
  filterState,
  gravatar,
  idAsyncJob,
  importType,
  inventories,
  isExportLoading,
  isSubmittingForm,
  libraries,
  libraryDetail,
  modifierIds,
  modifiers,
  newCategory,
  openRightColumn,
  outlets,
  previousCategories,
  previousCategoryId,
  previousLibraryForm,
  removeImage,
  search,
  showCOGSModal,
  showDeleteLibraryModal,
  showDeleteModal,
  showImportModal,
  showInputCOGS,
  showInputInventory,
  showLibraryInventoryAlertModal,
  showLibraryVariantModal,
  showNewCategoryModal,
  showSaveToAllOutletsModal,
  showSectionUploader,
  showUploadValidationModal,
  tempFiles,
  textModal,
  totalPage,
  uncategorized,
  units,
});
